import React, { useEffect } from "react";
import "./TestPage.css";

const TestPage = () => {
  useEffect(() => {
    const snowContainer = document.getElementById("snow-container");

    const createSnowflake = () => {
      const snowflake = document.createElement("div");
      snowflake.className = "snowflake";
      snowflake.textContent = "❄";

      // Random positioning and style
      snowflake.style.left = `${Math.random() * 100}vw`;
      snowflake.style.animationDuration = `${Math.random() * 3 + 4}s`; // Between 2s and 7s
      snowflake.style.animationDelay = `${Math.random() * 5}s`; // Random delay
      snowflake.style.fontSize = `${Math.random() * 1.5 + 0.5}em`; // Random size

      snowContainer.appendChild(snowflake);

      // Remove the snowflake after it falls
      setTimeout(() => {
        snowflake.remove();
      }, 5000);
    };

    const interval = setInterval(createSnowflake, 200);

    return () => clearInterval(interval); // Cleanup on component unmount
  }, []);

  return (
    <div id="container">
      <div id="snow-container"></div>
    </div>
  );
};

export default TestPage;
